import React, { useState } from 'react'
import {
  SurveyParticipantsQuery,
  useSurveyParticipantsQuery
} from './SurveySend.codegen'
import {
  SqlOrderDirectionEnum,
  SurveyManageUsersOverviewOrderColumn
} from '../../../../graphql/private/PrivateSchemaTypes'
import { ManageSurveyContext } from '../ManageSurveyContext'
import { DEFAULT_PAGE_LIMIT } from '../../../../components/common/table-extended-old/TableExtendedOld'

type SurveyParticipantsContextType = {
  changeFilter: (changes) => void
  tableFilters: {
    page: number
    limit: number
    order: SurveyManageUsersOverviewOrderColumn
    orderDirection: SqlOrderDirectionEnum
    search: string
  }
  loading: boolean
  survey: NonNullable<SurveyParticipantsQuery['admin']>['survey']
  refetchUsers: () => Promise<void>
}

export const SurveyParticipantsContext =
  React.createContext<SurveyParticipantsContextType>(
    null as unknown as SurveyParticipantsContextType
  )

export const WithSurveyParticipantsContext: React.FC = ({ children }) => {
  const { survey } = React.useContext(ManageSurveyContext)

  const [tableFilters, setTableFilters] = useState({
    page: 0,
    limit: DEFAULT_PAGE_LIMIT,
    order: SurveyManageUsersOverviewOrderColumn.display_name,
    orderDirection: SqlOrderDirectionEnum.DESC,
    search: ''
  })

  const changeFilter = React.useCallback((changes) => {
    setTableFilters((currTableFilters) => ({
      ...currTableFilters,
      ...changes
    }))
  }, [])

  const {
    data,
    loading,
    refetch: refetchUsers
  } = useSurveyParticipantsQuery({
    variables: {
      id: survey.id,
      order: tableFilters.order,
      orderDirection: tableFilters.orderDirection,
      search: tableFilters.search,
      limit: tableFilters.limit,
      offset: tableFilters.page * tableFilters.limit
    }
  })
  const ctx = React.useMemo(() => {
    return {
      changeFilter,
      tableFilters,
      loading,
      survey: data?.admin?.survey,
      refetchUsers
    }
  }, [data, loading, tableFilters])

  return (
    <SurveyParticipantsContext.Provider value={ctx}>
      {children}
    </SurveyParticipantsContext.Provider>
  )
}
